import React from 'react';
import { Search, RotateCcw } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { Select } from '../library/LibraryToolbar';
import { LEVELS } from './simUtils';

export const SimToolbar = ({ list, level, setLevel, categories, onReset }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const all = { value: 'all', label: L('الكل', 'All') };
  const levels = [all, ...LEVELS.map(l => ({ value: String(l.value), label: lang === 'ar' ? l.ar : l.en }))];
  const cats = [all, ...categories.map(c => ({ value: c.id, label: lang === 'ar' ? c.nameAr : (c.nameEn || c.nameAr) }))];
  const dirty = list.dirty || level !== 'all';
  return (
    <div data-testid="sims-toolbar" className="flex flex-col lg:flex-row gap-3 mb-6">
      <div className="relative flex-1">
        <Search className="absolute start-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
        <input data-testid="sims-search-input" value={list.query} onChange={(e) => list.setQuery(e.target.value)} placeholder={L('ابحث عن محاكاة...', 'Search for a simulation...')}
          className="w-full h-14 rounded-2xl bg-white border border-slate-200 ps-12 pe-4 text-sm sm:text-base outline-none placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-[border-color,box-shadow]" />
      </div>
      <div className="grid grid-cols-2 sm:flex gap-3">
        <Select testId="sims-level-select" label={L('المستوى', 'Level')} value={level} onChange={setLevel} options={levels} />
        <Select testId="sims-category-select" label={L('الفئة', 'Category')} value={list.cat} onChange={list.setCat} options={cats} />
        <button type="button" data-testid="sims-reset-btn" onClick={onReset} disabled={!dirty}
          className="col-span-2 sm:col-span-1 h-14 px-5 rounded-2xl border-2 border-blue-200 text-blue-700 font-bold text-sm inline-flex items-center justify-center gap-2 hover:bg-blue-50 disabled:opacity-50 disabled:hover:bg-transparent transition-colors">
          <RotateCcw className="w-4 h-4" />{L('إعادة تعيين الفلاتر', 'Reset filters')}
        </button>
      </div>
    </div>
  );
};
